// src/components/Layout.js
import React from 'react';
import Sidebar from './Sidebar';

const Layout2 = ({ children }) => {
  return (
    <div className="public-shell flex h-screen" style={{height:"100vh"}}>
   
      
      {/* Main Content with independent scroll */}
      <main className="public-main flex-1 p-6 bg-white overflow-auto">
        {children}
      </main>
    </div>
  );
};

export default Layout2;
